// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/src/packages/www/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/loading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__index' */'@/layouts/index.tsx'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/function/qrcode",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__function__qrcode__index' */'@/pages/function/qrcode/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/function/qrcode"
      },
      {
        "path": "/function/reseturl",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__function__reseturl__index' */'@/pages/function/reseturl/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/function/reseturl"
      },
      {
        "path": "/index.html",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__index__index' */'@/pages/index/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/"
      },
      {
        "path": "/",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__index__index' */'@/pages/index/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/"
      },
      {
        "path": "/lenovoid/bindmobile",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__lenovoid__bindmobile__index' */'@/pages/lenovoid/bindmobile/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/lenovoid/bindmobile"
      },
      {
        "path": "/loginout",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__loginout__index' */'@/pages/loginout/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/loginout"
      },
      {
        "path": "/micro/:micro",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__micro__micro' */'@/pages/micro/[micro].tsx'), loading: LoadingComponent}),
        "rawPath": "/micro/:micro"
      },
      {
        "path": "/middlepage/lexiang",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__middlepage__lexiang__index' */'@/pages/middlepage/lexiang/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/middlepage/lexiang"
      },
      {
        "path": "/middlepage/live",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__middlepage__live__index' */'@/pages/middlepage/live/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/middlepage/live"
      },
      {
        "path": "/middlepage/shop",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__middlepage__shop__index' */'@/pages/middlepage/shop/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/middlepage/shop"
      },
      {
        "path": "/middlepage/upstream",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__middlepage__upstream__index' */'@/pages/middlepage/upstream/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/middlepage/upstream"
      },
      {
        "path": "/middlepage/yxt",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__middlepage__yxt__index' */'@/pages/middlepage/yxt/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/middlepage/yxt"
      },
      {
        "path": "/oauth2/authorize",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__oauth2__authorize__index' */'@/pages/oauth2/authorize/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/oauth2/authorize"
      },
      {
        "path": "/personal/bindmobile",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__personal__bindmobile__index' */'@/pages/personal/bindmobile/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/personal/bindmobile"
      },
      {
        "path": "/personal/bindwechat",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__personal__bindwechat__index__index' */'@/pages/personal/bindwechat/index/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/personal/bindwechat/index"
      },
      {
        "path": "/personal/bindwechat/qrcode",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__personal__bindwechat__qrcode__index' */'@/pages/personal/bindwechat/qrcode/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/personal/bindwechat/qrcode"
      },
      {
        "path": "/personal/changemobile",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__personal__changemobile__index' */'@/pages/personal/changemobile/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/personal/changemobile"
      },
      {
        "path": "/personal/editpwd",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__personal__editpwd__index' */'@/pages/personal/editpwd/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/personal/editpwd"
      },
      {
        "path": "/personal/forgetpwd",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__personal__forgetpwd__index' */'@/pages/personal/forgetpwd/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/personal/forgetpwd"
      },
      {
        "path": "/personal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__personal__index__index' */'@/pages/personal/index/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/personal/index"
      },
      {
        "path": "/personal/lowresetpsd",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__personal__lowresetpsd__index' */'@/pages/personal/lowresetpsd/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/personal/lowresetpsd"
      },
      {
        "path": "/personal/resetpwd",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__personal__resetpwd__index' */'@/pages/personal/resetpwd/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/personal/resetpwd"
      },
      {
        "path": "/register/activation",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__register__activation__index' */'@/pages/register/activation/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/register/activation"
      },
      {
        "path": "/register/bindmobile",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__register__bindmobile__index' */'@/pages/register/bindmobile/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/register/bindmobile"
      },
      {
        "path": "/register",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__register__index__index' */'@/pages/register/index/index.tsx'), loading: LoadingComponent}),
        "rawPath": "/register/index"
      }
    ],
    "rawPath": "/"
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
